import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAntrepoOfferRequest } from '../models/request/antrepoOffer/AddAntrepoOfferRequest';
import { GetAntrepoOfferListPagingAndFilterRequest } from '../models/request/antrepoOffer/GetAntrepoOfferListPagingAndFilterRequest';
// import { GetAntrepoOfferListPagingAndFilterRequest } from '../models/request/antrepoOffer/GetAntrepoOfferListPagingAndFilterRequest';

export class AntrepoOfferService {
    static async getAntrepoOfferList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getAntrepoOfferList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOffer/getAntrepoOfferList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async changeAntrepoOfferStatus(_antrepoOfferId: string | undefined, _offerStatusId: string) {
        try {
            var inputObj = {
                antrepoOfferId: _antrepoOfferId,
                offerStatusId: _offerStatusId
            };

            console.log('SERVICE CALL - changeAntrepoOfferStatus', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOffer/changeAntrepoOfferStatus', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async copyAntrepoOffer(_antrepoOfferId: string | undefined) {
        try {
            var inputObj = {
                antrepoOfferId: _antrepoOfferId
            };

            console.log('SERVICE CALL - copyAntrepoOffer', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOffer/copyAntrepoOffer', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAntrepoOfferList(inputObj: GetAntrepoOfferListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAntrepoOfferList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOffer/exportAntrepoOfferList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoOfferListPagingAndFilter(inputObj: GetAntrepoOfferListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAntrepoOfferListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOffer/GetAntrepoOfferListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addAntrepoOffer(inputObj: AddAntrepoOfferRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddAntrepoOffer', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOffer/AddAntrepoOffer', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAntrepoOffer(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAntrepoOffer', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOffer/deleteAntrepoOffer', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoOfferById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getAntrepoOfferById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoOffer/getAntrepoOfferById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}